/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import InputMask from 'react-input-mask';
import { getFormItemClassName } from '../../helpers/form';
import { IFormItemProps } from '../../types/components/form';
import { IInputLayout } from '../../types/layout/input';

type TInputProps = IInputLayout & IFormItemProps & {
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
};

function Input({
    disabled, placeholder, onChange, value, options, mask, validation, additionalClassName, onKeyDown,
}: TInputProps) {
    const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        if (typeof onChange === 'function') {
            onChange(e.target.value);
        }
    };

    return (
        <InputMask
            mask={mask || ''}
            className={getFormItemClassName('form-control', additionalClassName)}
            disabled={disabled}
            value={value}
            type={options?.type}
            placeholder={placeholder}
            onChange={onChangeHandler}
            min={validation?.min}
            max={validation?.max}
            maxLength={validation?.maxLength}
            onKeyDown={onKeyDown}
        />
    );
}

Input.defaultProps = {
    title: undefined,
    placeholder: undefined,
    onChange: undefined,
    value: undefined,
    onKeyDown: undefined,
};

export default Input;
